import React, { useCallback, useState } from "react";
import { Autocomplete, createStyles, Select } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { debounce } from "../../utils/index";

const useStyles = createStyles((theme) => ({
  row: {
    margin: "auto",
    // width: "30%",
    display: "flex",
    justifyContent: "center",
    borderRadius: "12px",
    // border: "1px solid #F2F2F2",
    background: "#FFF",
    padding: "10px",
    "@media (max-width:1300px)": {
      width: "55%",
    },
    "@media (max-width:500px)": {
      width: "95%",
    },
  },

  searchbox: {
    width: "100%",
    border: "none",
  },
}));

function BillingSearchBar({
  placeholder,
  data,
  onChange,
  value,
  setValue,
  // setLoading,

  ...props
}) {
  const { classes } = useStyles();

  const debouncedSearch = useCallback(
    debounce((value) => {
      onChange(value);
    }, 700),
    []
  );

  const handleChange = (value) => {
    setValue(value);
    debouncedSearch(value);
    // setLoading(false)
  };

  return (
    <div>
      <div className={classes.row}>
        <Autocomplete
          {...props}
          icon={<IconSearch size={25} />}
          maxDropdownHeight={200}
          rightSectionWidth={30}
          styles={{ rightSection: { pointerEvents: "none" } }}
          className={classes.searchbox}
          placeholder={placeholder}
          data={data}
          value={value}
          onChange={handleChange}
          nothingFound={!value ? null : "No data found"}
          filter={() => true}
          limit={Infinity}
        />
      </div>
    </div>
  );
}

export default BillingSearchBar;
